module.exports = __webpack_public_path__ + "static/media/edit-icon.ba47f3d1.svg";